module.exports = __webpack_public_path__ + "img/banner6.272726d8.png";